import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { WorkShiftsTableComponent } from '../../work-shifts-table.component';
import { AuthService } from '../../../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shift-button-wrapper',
  templateUrl: './work-shift-button-wrapper.component.html',
  styleUrls: ['./work-shift-button-wrapper.component.scss'],
  standalone: false,
})
export class WorkShiftButtonWrapperComponent {
  @Input() cellPopContent;
  @Input() cellPrevPopContent;
  @Input() cell;
  @Input() isPreviewCell;
  @Input() cellPopoverIsOpen;
  @Input() templateFilter;
  @Input() index;
  @Input() endIndex;
  @Input() title;
  @Input() user;

  @Output() onOpenEditConfirmDialog = new EventEmitter<any>();
  @Output() showCell = new EventEmitter<void>();
  @Output() hideCell = new EventEmitter<void>();

  constructor(
    private authService: AuthService
  ) {}

  get isGRS() {
    return this.authService.isGRSUser();
  }
}
